<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="title">
						<h2>Kerkesat per transport</h2>
					</div>
				</div>
			</div>
			<div class="row d-flex">
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
					<div class="btn-dashboard">
						<button
							v-bind:class="{ tablinks: true, active: requestType === 'unconfirmed' }"
							@click="setRequestType('unconfirmed')"
						>Pa konfirmuara</button>
					
					</div>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
					<div class="btn-dashboard ">
						<button
					v-bind:class="{ tablinks: true, active: requestType === 'confirmed' }"
					@click="setRequestType('confirmed')"
				>konfirmuara</button>
					</div>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
					<div class="btn-dashboard">
						<router-link tag="a" to="/admin/requests/add">shto kerkese</router-link>
					</div>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
					<div class="btn-dashboard">
						<select name="pickup-filters">
							<option value="volvo">Filtro sipas</option>
							<option value="volvo">Lloji i veturës</option>
							<option value="volvo">Lloji i veturës</option>
						</select>
					</div>
				</div>
			</div>
			<div class='row'>
				
			</div>
			<div id="passwordChange" class>
				<div class="row" v-if="requestType === 'unconfirmed'">
					<p v-if="requestCount === 0" style="paddingLeft: 15px">Nuk ka kerkesa per momentin</p>
					<div class="col-lg-4 col-md-6 col-sm-12" v-for="request in requests" :key="request.id">
						<div class="requests">
							<ul>
							<li class="width-70">
								<h3>User ID</h3>
								<!-- <span>{{ request.requester }}: </span> -->
								<span>{{ request.requester_details.first_name }} {{ request.requester_details.last_name }} ({{ request.requester_details.user_type }})</span>
								
							</li>
							<li class="width-30">
								<h2>{{ request.request_type }}</h2>
							</li>
							<li class="width-70">
								
							</li>
							<li class="width-30"></li>
							<li class="width-70">
								<h3>Adresa</h3>
								<p v-if="request.address != '-'">{{ request.address }}</p>
								<p v-else>Adresa</p>
								<p><a :href="`https://www.google.com/maps?q=${request.latitude},${request.longitude}`" target="_blank"> (kliko)</a></p>
							</li>
							<li class="width-30">
								<h3>Koha</h3>
								<p>{{ request.created_at | moment("DD.MM.YYYY") }}</p>
								<p>{{ request.created_at | moment("HH:mm") }}</p>
							</li>
							<li class="width-70">
								<h3>Nr. i thirrjeve</h3>
								<p>{{ request.number_of_times_called }}</p>
							</li>
								<li class="width-30">
								
							</li>
							</ul>
							<hr>
							<router-link tag="a" :to="{ name: 'admin/request/detail', params: { id: request.id }}" style="color: #edc239"><strong>SHIH DETAJET</strong></router-link>
							<!-- <ul class="decide">
								
							<li>
								<router-link tag="a" :to="{ name: 'admin/request/detail', params: { id: request.pk }}">
									<i class="fa fa-check" aria-hidden="true"></i>
								</router-link>
							</li>
							<li>
								<router-link tag="a" :to="{ name: 'admin/request/detail', params: { id: request.pk, action: 'cancel' }}">
									<i class="fa fa-times" aria-hidden="true"></i>
								</router-link>
							</li>
							</ul> -->
						</div>
					</div>
				</div>
				<div class="row" v-if="requestType === 'confirmed'">
					<p v-if="requestCount === 0" style="paddingLeft: 15px">Nuk ka kerkesa per momentin</p>
					<div class="col-lg-4 col-md-6 col-sm-12" v-for="request in requests" :key="request.id">
					<div class="requests">
						<ul>
						<li class="width-70">
							<h3>User ID</h3>
							<!-- <span>{{ request.requester }}</span> -->
							<h3>{{ request.requester_details.first_name }} {{ request.requester_details.last_name }} ({{ request.requester_details.user_type }})</h3>
						</li>
						<li class="width-30">
							<h2>{{ request.request_type }}</h2>
						</li>
						<li class="width-70">
							<!-- <h3>{{ request.requester_details.first_name }} {{ request.requester_details.last_name }} ({{ request.requester_details.user_type }})</h3> -->
						</li>
						<li class="width-30"></li>
					
						<li class="width-70">
							<h3>Adresa</h3>
							<p v-if="request.address != '-'">{{ request.address }}</p>
							<p v-else>Adresa</p>
							<p><a :href="`https://www.google.com/maps?q=${request.latitude},${request.longitude}`" target="_blank"> (kliko)</a></p>
						</li>
						<li class="width-30">
							<h3>Koha</h3>
							<p>{{ request.created_at | moment('DD.MM.YYYY') }}</p>
							<p>{{ request.created_at | moment('HH:mm') }}</p>
						</li>
						</ul>
						<hr>
						<router-link
						tag="h4"
						:to="{ name: 'admin/request/detail', params: { id: request.id }}"
						style="color: #edc239"
						>E konfirmuar</router-link>
					</div>
					</div>
				</div>
				<div class="row justify-content-center alig-items-center" v-if="requestCount > perPageTotal">
					<div class="col-12">
					<div class="prev-next">
						<ul>
						<li v-if="currentPage > 1">
							<button @click="getCurrentPage(currentPage-1)">
							<i class="fas fa-long-arrow-alt-left"></i>
							</button>
						</li>
						<li v-if="currentPage > 3 && totalPages > 5">
							<button>...</button>
						</li>
						<li v-for="pageNr in pageButtonsArray()" :key="pageNr">
							<button
							v-if="pageNr !== currentPage"
							@click="getCurrentPage(pageNr)"
							>{{ pageNr }}</button>
							<button v-if="pageNr === currentPage" @click="getCurrentPage(pageNr)">
							<strong>{{ pageNr }}</strong>
							</button>
						</li>
						<li v-if="currentPage < totalPages - 2 && totalPages > 5">
							<button>...</button>
						</li>
						<li v-if="currentPage !== totalPages">
							<button @click="getCurrentPage(currentPage+1)">
							<i class="fas fa-long-arrow-alt-right"></i>
							</button>
						</li>
						</ul>
					</div>
					</div>
				</div>
				</div>
			</div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import "moment";

export default {
  name: "AdminRequests",
  components: {
    AdminSidebar: AdminSidebar
  },
  computed: {
    ...mapGetters({
      requests: "requests/requests",
      requestType: "requests/requestType",
      requestCount: "requests/requestCount",
      currentPage: "requests/currentPage",
      totalPages: "requests/totalPages",
      perPageTotal: "requests/perPageTotal"
    })
  },
  methods: {
    setRequestType(value) {
      this.$store.dispatch("requests/getRequestType", value);
    },
    getCurrentPage(value) {
      this.$store.dispatch("requests/getCurrentPage", value);
    },
    range(start, stop, step) {
      if (typeof stop == "undefined") {
        stop = start;
        start = 0;
      }
      if (typeof step == "undefined") {
        step = 1;
      }
      if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
      }
      var result = [];
      for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
      }

      return result;
    },
    pageButtonsArray() {
      const { currentPage, totalPages, range } = this;
      let a = 0;
      let b = 0;

      if (totalPages < 6) {
        return range(1, totalPages + 1);
      }

      if (currentPage < 4) {
        a = 1;
        b = 5;
      } else if (totalPages - currentPage < 3) {
        a = totalPages - 4;
        b = totalPages;
      } else {
        a = currentPage - 2;
        b = currentPage + 2;
      }

      return range(a, b + 1);
    }
  },
  beforeMount() {
    this.$store.dispatch("requests/getRequestList");
  }
};
</script>
